module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.type == 'reset') ? [_vm._m(0)] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacesso') ? [_vm._m(1)] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_vm._m(2)] : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), (_vm.type == 'reset') ? [_c('p', [_vm._v("Redefinir sua senha de acesso.")])] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacessso') ? [_c('p', [_vm._v("Para começar defina uma senha de acesso.")])] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_c('p', [_vm._v("Redefinir sua senha de acesso.")])] : _vm._e()], 2)]), _vm._v(" "), (_vm.is2FA) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t10"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro: ")]), _vm._v("\n                " + _vm._s(_vm.errorMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doReset.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Nova senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        'required|min:8|max:20|confirmed:password|moveMaisCPF'
      ),
      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password",
      "data-vv-validate-on": "blur",
      "maxlength": "20",
      "placeholder": "Mínimo 8 e máximo 20 caracteres"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, _vm.checkPassword]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('passwordRepeat')
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordRepeat"
    }
  }, [_vm._v("Confirme a nova senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordRepeat),
      expression: "passwordRepeat"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        'required|min:8|max:20|confirmed:password|moveMaisCPF'
      ),
      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "passwordRepeat",
      "type": "password",
      "name": "passwordRepeat",
      "data-vv-validate-on": "blur",
      "maxlength": "20",
      "placeholder": "Mínimo 8 e máximo 20 caracteres"
    },
    domProps: {
      "value": (_vm.passwordRepeat)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordRepeat = $event.target.value
      }, _vm.checkPasswordRepeat]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("passwordRepeat")) + "\n                  ")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    attrs: {
      "id": "btn-new-pass",
      "type": "submit",
      "name": "button",
      "disabled": _vm.validPasswordRepeat == false
    }
  }, [_vm._v("\n                  Definir nova senha\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": {
        name: 'login'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v(" Voltar\n            ")])], 1)])])]) : _vm._e(), _vm._v(" "), (!_vm.is2FA) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t10"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro!")]), _vm._v("\n                " + _vm._s(_vm.errorMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doReset.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Nova senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        'required|min:8|max:20|confirmed:password|moveMaisCPF'
      ),
      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password",
      "maxlength": "20",
      "placeholder": "Digite sua nova senha"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('passwordRepeat')
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordRepeat"
    }
  }, [_vm._v("Confirme a nova senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordRepeat),
      expression: "passwordRepeat"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        'required|min:8|max:20|confirmed:password|moveMaisCPF'
      ),
      expression: "\n                      'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                    "
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "passwordRepeat",
      "type": "password",
      "name": "passwordRepeat",
      "data-vv-validate-on": "blur",
      "maxlength": "20",
      "placeholder": "Confirme sua nova senha"
    },
    domProps: {
      "value": (_vm.passwordRepeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordRepeat = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("passwordRepeat")) + "\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    attrs: {
      "id": "btn-new-pass",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                  Definir nova senha\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": {
        name: 'login'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v(" Voltar\n            ")])], 1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_vm._v("\n            Identificação "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Redefinir\n            senha\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_vm._v("\n            Primeiro Acesso "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Definir\n            senha\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_vm._v("\n            Identificação "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Redefinir\n            senha\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                      Senha deve ter de 8 a 20 caracteres\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                      Senha deve ter pelo menos um número\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                      Senha deve ter uma letra maiúscula\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                      Senha deve ter um caractere especial\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter de 8 a 20 caracteres")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter pelo menos um número")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter uma letra maiúscula")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                  Senha deve ter um caractere especial\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-ec452d44!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/password-set.vue
// module id = 2223
// module chunks = 1